import * as yup from "yup";
import { CUITRegex } from "../utils/regex";

export const PersonaJuridicaSchema = yup.object().shape({
  CUIT: yup
    .string()
    .matches(CUITRegex, "errors.personaJuridica.CUIT.regex")
    .length(11, "errors.personaJuridica.CUIT.length")
    .required("errors.personaJuridica.CUIT.required")
    .default(""),
  razonSocial: yup
    .string()
    .max(100, "errors.personaJuridica.razonSocial.max")
    .required("errors.personaJuridica.razonSocial.required")
    .default(""),
});
